import { useEffect } from 'react';

export const INTERCOM_BANNER_OFFSET_VARIABLE = '--intercom-banner-offset';

/**
 * Intercom top banners are fixed at the top of the viewport and make room for themselves by setting an
 * inline `margin-top` on `<body>`. This mirrors that margin into a CSS variable on `<html>` so sticky and
 * fixed nav elements can sit below the banner instead of sliding underneath it.
 */
export function useIntercomBannerOffsetVariable(): void {
  useEffect(() => {
    const root = document.documentElement;
    const syncOffset = (): void => {
      const offset = parseFloat(document.body.style.marginTop) || 0;
      root.style.setProperty(INTERCOM_BANNER_OFFSET_VARIABLE, `${offset}px`);
    };
    syncOffset();

    const observer = new MutationObserver(syncOffset);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['style'],
    });

    return (): void => {
      observer.disconnect();
      root.style.removeProperty(INTERCOM_BANNER_OFFSET_VARIABLE);
    };
  }, []);
}
